import styled from 'styled-components'
import { TagsType } from '../utils/getTagPhrase'

export const NotFoundInfo = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1rem;
  text-align: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const HeadSection = styled.section`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
  }
`

export const InfoSection = styled.section`
  width: 100%;
`

export const WrapperTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.padding(1)};
`

export const TagsInfo = styled.div<{ type: TagsType }>`
  border-radius: 8px;
  padding: ${({ theme }) => theme.padding(1)} ${({ theme }) => theme.padding(2)};
  background-color: transparent;
  color: black;
  font-weight: 700;
  font-size: 0.8rem;
  display: flex;
  gap: ${({ theme }) => theme.padding(1)};
  text-transform: uppercase;
`

export const WrapperInfo = styled.section`
  margin: ${({ theme }) => theme.padding(1)} 0;
  h5 {
    margin: ${({ theme }) => theme.padding(2)} 0;
  }
  p {
    text-align: justify;
  }
`

export const WrapperWarnings = styled.small``
